
import { DEFAULT_LANDING_SUBDOMAIN, LANDING_PAGE_DOMAIN } from "@/services/constants";
import { AddLandingPageSubdomain, getLandingPageSubdomain, UpdateLandingPageSubdomain } from "@/store/landingPageSubdomain/actions"
import { LandingPageUrl } from "@dev/ee-api/ee-api-models";
import { useDispatch, useSelector } from "react-redux"

export const useLandingPageSubdomain = () => {
    const {accountSubdomain,landingPageSubdomain,loading} = useSelector(getLandingPageSubdomain)
    const dispatch = useDispatch();


    const changeSubdomain = (payload: LandingPageUrl) => dispatch<any>(landingPageSubdomain?.UrlPrefix ? UpdateLandingPageSubdomain(payload): AddLandingPageSubdomain(payload))
    const currentSubdomain = accountSubdomain || DEFAULT_LANDING_SUBDOMAIN;
    const checkoutBaseUrl = accountSubdomain ? `https://${currentSubdomain}.${LANDING_PAGE_DOMAIN}` : null;

    return {
        changeSubdomain,
        accountSubdomain,
        currentSubdomain,
        landingPageSubdomain,
        loading,
        checkoutBaseUrl
    }
}